import React from 'react';
import { cn } from '../lib/utils';

/** Full horizontal BENTA logo (navy + teal on transparent/white). Best on light surfaces. */
export function BentaLogo({ className = '', alt = 'BENTA' }) {
  return <img src="/benta-logo.png" alt={alt} className={cn('object-contain', className)} />;
}

/** Square BENTA app mark. Works on any background. */
export function BentaMark({ className = '' }) {
  return <img src="/benta-icon.png" alt="BENTA" className={cn('object-contain rounded-lg', className)} />;
}

/** Text wordmark for dense/dark contexts (POS header, etc.). */
export function BentaWordmark({ className = '', accentClassName = 'text-secondary' }) {
  return (
    <span className={cn('font-heading font-extrabold tracking-tight leading-none', className)}>
      BEN<span className={accentClassName}>TA</span>
    </span>
  );
}

export default BentaLogo;
